import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

export const initSentry = () => {
  //   Sentry.init({
  //     dsn: 'https://6b515331d9e341acbd63a8bdc50c8288@o1350957.ingest.sentry.io/6631177',
  //     enabled: process.env.REACT_APP_SENTRY_ENABLED === 'true',
  //     integrations: [new BrowserTracing()],
  //     environment: process.env.REACT_APP_ENV,
  //     release: process.env.REACT_APP_VERSION,

  //     // Set tracesSampleRate to 1.0 to capture 100%
  //     // of transactions for performance monitoring.
  //     // We recommend adjusting this value in production
  //     tracesSampleRate: 1.0,
  //   });

  //   follow this guide to enable more - https://docs.sentry.io/platforms/javascript/guides/react/

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN_ID,
    enabled: process.env.REACT_APP_SENTRY_ENABLED === 'true',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        blockAllMedia: false,
        maskAllInputs: false, // Mask all input fields
        maskAllText: false, // Mask all visible text
      }),
      // See docs for support of different versions of variation of react router
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    environment: process.env.REACT_APP_ENV,
    release: process.env.REACT_APP_VERSION,

    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
};
